document.addEventListener("DOMContentLoaded", function() {
    
    // Initialize WooCommerce tabs functionality (replaces jQuery-based tabs)
    initProductTabs();
    
    // Initialize star rating input for reviews
    initStarRating();
    
    // Existing quantity functionality
    const quantityInput = document.querySelector(".quantity-input");
    const minusBtn = document.querySelector(".quantity-minus");
    const plusBtn = document.querySelector(".quantity-plus");

    // Quantity button functionality
    if (quantityInput && minusBtn && plusBtn) {
        const maxQuantity = quantityInput.hasAttribute("max") ? parseInt(quantityInput.getAttribute("max")) : 999999;
        
        minusBtn.addEventListener("click", function() {
            let currentValue = parseInt(quantityInput.value) || 1;
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
        });
        
        plusBtn.addEventListener("click", function() {
            let currentValue = parseInt(quantityInput.value) || 1;
            if (currentValue < maxQuantity) {
                quantityInput.value = currentValue + 1;
            }
        });
        
        quantityInput.addEventListener("change", function() {
            let value = parseInt(this.value) || 1;
            let min = 1;
            
            if (value < min) this.value = min;
            if (maxQuantity > 0 && value > maxQuantity) this.value = maxQuantity;
        });
    }

    // Initialize Swiper for product images
    initProductImageSwiper();

    // Initialize shipping clock
    updateShippingClock();

    // Initialize variant image hover functionality
    initVariantImageHover();

    // Initialize description panel toggle
    descriptionPanelToggle();
});

/**
 * WooCommerce Tabs functionality - vanilla JS replacement for jQuery tabs
 */
function initProductTabs() {
    const tabsWrapper = document.querySelector('.woocommerce-tabs');
    if (!tabsWrapper) return;
    
    const tabsList = tabsWrapper.querySelector('.wc-tabs');
    const tabLinks = tabsList ? tabsList.querySelectorAll('li a') : [];
    const tabPanels = tabsWrapper.querySelectorAll('.wc-tab');
    
    if (tabLinks.length === 0 || tabPanels.length === 0) return;
    
    // Hide all panels except first one and set first tab as active
    tabPanels.forEach((panel, index) => {
        if (index === 0) {
            panel.style.display = 'block';
        } else {
            panel.style.display = 'none';
        }
    });
    
    // Set first tab as active
    if (tabLinks.length > 0) {
        tabLinks[0].parentElement.classList.add('active');
    }
    
    // Add click handlers to tab links
    tabLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('href');
            const targetPanel = document.querySelector(targetId);
            
            if (!targetPanel) return;
            
            // Remove active class from all tabs
            tabLinks.forEach(l => l.parentElement.classList.remove('active'));
            
            // Hide all panels
            tabPanels.forEach(panel => panel.style.display = 'none');
            
            // Show target panel and activate tab
            targetPanel.style.display = 'block';
            this.parentElement.classList.add('active');
            
            // Check if description button should be shown (when switching to description tab)
            if (targetId === '#tab-description') {
                setTimeout(toggleDescriptionButton, 50);
            }
        });
    });
    
    // Initial check for description button
    setTimeout(toggleDescriptionButton, 100);
}

/**
 * Star Rating Input for Reviews
 */
function initStarRating() {
    const starContainer = document.querySelector('.star-rating-input');
    if (!starContainer) return;
    
    const ratingInput = starContainer.querySelector('input[name="rating"]');
    const starButtons = starContainer.querySelectorAll('.star-btn');
    
    if (!ratingInput || starButtons.length === 0) return;
    
    // Update stars visual state
    function updateStars(rating, isHover = false) {
        starButtons.forEach((btn) => {
            const svg = btn.querySelector('svg');
            const starRating = parseInt(btn.dataset.rating, 10);
            
            if (starRating <= rating) {
                svg.classList.remove('text-gray-300');
                svg.classList.add('text-yellow-400');
            } else if (!isHover) {
                svg.classList.remove('text-yellow-400');
                svg.classList.add('text-gray-300');
            } else {
                svg.classList.remove('text-yellow-400');
                svg.classList.add('text-gray-300');
            }
        });
    }
    
    // Click handler - set rating
    starButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            const rating = parseInt(this.dataset.rating, 10);
            ratingInput.value = rating;
            updateStars(rating);
        });
        
        // Hover handlers for preview effect
        btn.addEventListener('mouseenter', function() {
            const rating = parseInt(this.dataset.rating, 10);
            updateStars(rating, true);
        });
    });
    
    // Mouse leave - restore selected rating
    starContainer.addEventListener('mouseleave', function() {
        const currentRating = parseInt(ratingInput.value, 10) || 0;
        updateStars(currentRating);
    });
}

// Variant image hover functionality
let originalGalleryContent = null;
let currentVariantSrc = null;

const saveOriginalGalleryContent = () => {
    const gallery = document.querySelector('.woocommerce-product-gallery');
    if (gallery && !originalGalleryContent) {
        originalGalleryContent = gallery.innerHTML;
    }
};

const showVariantImage = (variantImageSrc, variantImageAlt = 'Variant image') => {
    const gallery = document.querySelector('.woocommerce-product-gallery');
    if (!gallery || !variantImageSrc) return;
    
    // Skip if already showing this variant
    if (currentVariantSrc === variantImageSrc) return;
    currentVariantSrc = variantImageSrc;

    // Create simplified gallery with only the variant image
    const simplifiedGallery = `
        <div class="swiper product-main-swiper swiper-horizontal swiper-autoheight swiper-watch-progress swiper-initialized swiper-backface-hidden">
            <div class="swiper-wrapper" style="height: auto;">
                <div class="swiper-slide max-md:min-h-[72vh] max-md:h-[72vh] swiper-slide-active">
                    <img class="rounded-lg w-full max-md:min-h-[72vh] max-md:h-[72vh] max-md:object-cover" 
                         src="${variantImageSrc}" 
                         alt="${variantImageAlt}" 
                         loading="eager" 
                         fetchpriority="high">
                </div>
            </div>
        </div>
    `;
    gallery.innerHTML = simplifiedGallery;
};

const restoreOriginalGallery = () => {
    const gallery = document.querySelector('.woocommerce-product-gallery');
    if (gallery && originalGalleryContent) {
        gallery.innerHTML = originalGalleryContent;
        currentVariantSrc = null;
        
        // Reinitialize Swiper after restoring content
        setTimeout(() => {
            initProductImageSwiper();
        }, 50);
    }
};

const initVariantImageHover = () => {
    saveOriginalGalleryContent();
    
    const productPattern = document.getElementById('product-pattern');
    if (!productPattern) return;
    
    // Each variant handles its own mouseenter
    productPattern.querySelectorAll('.product-variant').forEach(variant => {
        variant.addEventListener('mouseenter', () => {
            const variantImg = variant.querySelector('.pattern-variant-image');
            if (variantImg) {
                const variantImageSrc = variantImg.getAttribute('data-variant-image');
                const variantImageAlt = variantImg.getAttribute('alt') || 'Variant image';
                showVariantImage(variantImageSrc, variantImageAlt);
            }
        });
    });
    
    // Restore only when leaving the entire pattern container
    productPattern.addEventListener('mouseleave', () => {
        restoreOriginalGallery();
    });
};

// Update the initProductImageSwiper function to use local Swiper
function initProductImageSwiper() {
    // Check if Swiper is available and elements exist
    if (typeof Swiper === 'undefined') {
        console.warn('Swiper not loaded');
        return;
    }

    const mainSwiperEl = document.querySelector('.product-main-swiper');
    const thumbsSwiperEl = document.querySelector('.product-thumbs-swiper');
    
    if (!mainSwiperEl) {
        return;
    }

    let thumbsSwiper = null;
    
    // Initialize thumbs swiper first if it exists
    if (thumbsSwiperEl) {
        thumbsSwiper = new Swiper(thumbsSwiperEl, {
            modules: [Navigation, Thumbs],
            spaceBetween: 10,
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            freeMode: true,
        });
    }

    // Initialize main swiper
    const mainSwiper = new Swiper(mainSwiperEl, {
        modules: [Navigation, Pagination, Thumbs],
        spaceBetween: 10,
        autoHeight: true,
        watchOverflow: true,
        navigation: {
            nextEl: '.swiper_controls_next',
            prevEl: '.swiper_controls_prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            hideOnClick: false,
        },
        thumbs: thumbsSwiper ? {
            swiper: thumbsSwiper,
        } : undefined,
        breakpoints: {
            768: {
                pagination: {
                    enabled: false,
                },
            },
        },
    });

    // Handle thumbnail clicks manually if needed
    if (thumbsSwiper) {
        thumbsSwiperEl.addEventListener('click', function(e) {
            const clickedSlide = e.target.closest('.swiper-slide');
            if (clickedSlide) {
                const slideIndex = Array.from(clickedSlide.parentElement.children).indexOf(clickedSlide);
                mainSwiper.slideTo(slideIndex);
            }
        });
    }
}

let shippingClockState = {
    lastTimeDisplay: '',
    lastMessage: '',
    intervalId: null,
    timeElement: null,
    isActive: false
};

function updateShippingClock() {
    const timeElement = document.getElementById('time');
    if (!timeElement) return false;

    const personalizationButton = document.querySelector('.personalization-button');

    // If personalization button is present, show personalized product info
    if (personalizationButton) {
        timeElement.innerHTML = `
            <div class="text-sm">
                <p>Produkt Personalizowany</p>
                <p class="flex items-center whitespace-nowrap">Najbliższa wysyłka za<span class="text-green-700 flex items-center ml-1"> 1-2 dni robocze 
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="icon ml-1" width="20px" height="20px" viewBox="0 0 512 512">
                        <path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M256 64C150 64 64 150 64 256s86 192 192 192s192-86 192-192S362 64 256 64Z"></path>
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M256 128v144h96"></path>
                    </svg>
                    </span>
                </p>
            </div>
        `;
        return false; // No countdown for personalized products
    }

    const now = new Date();
    const currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, etc.
    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();

    // Calculate time until 13:00 today
    const today13 = new Date(now);
    today13.setHours(13, 0, 0, 0);
    
    const timeUntil13 = today13 - now;
    
    let message = '';
    let timeDisplay = '';
    let isCountdown = false;

    // Check if it's weekend (Saturday = 6, Sunday = 0)
    if (currentDay === 0 || currentDay === 6) {
        message = 'Najbliższa wysyłka już w poniedziałek:';
        timeDisplay = '13:00';
    }
    // Check if it's Friday after 13:00
    else if (currentDay === 5 && (currentHour > 13 || (currentHour === 13 && currentMinutes >= 0))) {
        message = 'Najbliższa wysyłka już w poniedziałek:';
        timeDisplay = '13:00';
    }
    // Check if it's Monday-Thursday after 13:00
    else if (currentDay >= 1 && currentDay <= 4 && (currentHour > 13 || (currentHour === 13 && currentMinutes >= 0))) {
        message = 'Najbliższa wysyłka już jutro:';
        timeDisplay = '13:00';
    }
    // It's before 13:00 on a weekday (Monday-Friday)
    else {
        message = 'Wysyłka dziś do:';
        isCountdown = true;
        
        // Calculate remaining time
        const hoursLeft = Math.floor(timeUntil13 / (1000 * 60 * 60));
        const minutesLeft = Math.floor((timeUntil13 % (1000 * 60 * 60)) / (1000 * 60));
        const secondsLeft = Math.floor((timeUntil13 % (1000 * 60)) / 1000);
        
        if (hoursLeft > 0) {
            timeDisplay = `${hoursLeft}:${minutesLeft.toString().padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`;
        } else {
            timeDisplay = `${minutesLeft}:${secondsLeft.toString().padStart(2, '0')}`;
        }
    }

    // Update the element content for regular products
    timeElement.innerHTML = `
        ${message} 
        <span class="ml-2 text-green-700 flex justify-center items-center">
            ${timeDisplay} 
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="icon ml-1" width="20px" height="20px" viewBox="0 0 512 512">
                <path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M256 64C150 64 64 150 64 256s86 192 192 192s192-86 192-192S362 64 256 64Z"></path>
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M256 128v144h96"></path>
            </svg>
        </span>
    `;
    
    // Return whether countdown is active
    return isCountdown;
}

// Clean up on page unload
window.addEventListener('beforeunload', function() {
    if (shippingClockState.intervalId) {
        clearInterval(shippingClockState.intervalId);
    }
});



function descriptionPanelToggle() {
    const button = document.getElementById('description-more-button');
    if (!button) return;
    
    const wrapper = document.querySelector('.description-wrapper');
    const content = document.querySelector('.description-content');
    const fade = document.querySelector('.description-fade');
    const toggleText = button.querySelector('.toggle-text');
    const toggleIcon = button.querySelector('.toggle-icon');
    
    if (!wrapper || !content) return;
    
    // Get full height of content
    function getFullHeight() {
        const clone = content.cloneNode(true);
        clone.style.maxHeight = 'none';
        clone.style.position = 'absolute';
        clone.style.visibility = 'hidden';
        wrapper.appendChild(clone);
        const height = clone.scrollHeight;
        wrapper.removeChild(clone);
        return height;
    }
    
    button.addEventListener('click', function() {
        const isCollapsed = wrapper.dataset.collapsed === 'true';
        
        if (isCollapsed) {
            // Expand
            const fullHeight = getFullHeight();
            content.style.maxHeight = fullHeight + 'px';
            wrapper.dataset.collapsed = 'false';
            if (toggleText) toggleText.textContent = 'Zwiń opis';
            if (toggleIcon) toggleIcon.style.transform = 'rotate(180deg)';
            if (fade) fade.style.opacity = '0';
        } else {
            // Collapse
            content.style.maxHeight = '20rem'; // max-h-80
            wrapper.dataset.collapsed = 'true';
            if (toggleText) toggleText.textContent = 'Rozwiń opis';
            if (toggleIcon) toggleIcon.style.transform = 'rotate(0deg)';
            if (fade) fade.style.opacity = '1';
        }
    });
}

// Add this to your theme's JavaScript file or in a script tag
function toggleDescriptionButton() {
    const descriptionTab = document.getElementById('tab-title-description');
    const descriptionButton = document.getElementById('description-more-button');
    const descriptionWrapper = document.querySelector('.description-wrapper');
    const descriptionContent = document.querySelector('.description-content');
    const descriptionFade = document.querySelector('.description-fade');
    
    // If there's no description button, exit early
    if (!descriptionButton) return;
    
    // If there's no description tab at all, hide the button
    if (!descriptionTab) {
        descriptionButton.classList.add('hidden');
        return;
    }
    
    // Get the description content to check its height
    if (!descriptionContent) {
        descriptionButton.classList.add('hidden');
        return;
    }
    
    // Check if content height exceeds max-height (20rem = 320px)
    const maxCollapsedHeight = 320;
    const contentScrollHeight = descriptionContent.scrollHeight;
    
    // If content is taller than collapsed height, show button
    if (contentScrollHeight > maxCollapsedHeight) {
        descriptionButton.classList.remove('hidden');
        if (descriptionFade) descriptionFade.style.opacity = '1';
    } else {
        descriptionButton.classList.add('hidden');
        // Remove max-height restriction and hide fade if content is short
        if (descriptionContent) descriptionContent.style.maxHeight = 'none';
        if (descriptionFade) descriptionFade.style.opacity = '0';
        if (descriptionWrapper) descriptionWrapper.dataset.collapsed = 'false';
    }
}

// Personalization button setup
document.addEventListener('DOMContentLoaded', function() {
    const personalizationButton = document.querySelector('.personalization-button');
    if (personalizationButton) {
        personalizationButton.setAttribute('data-trigger', 'personalization-modal');
    }
});